<template>
<div id="app">
	<AppBar />
	<transition name="fade" mode="out-in">
		<router-view></router-view>
	</transition>
	<Footer />
</div>
</template>

<script>
import AppBar from './components/AppBar';
import Footer from './components/Footer';

export default {
	name: 'App',
	components: {
		AppBar,
		Footer
	}
}
</script>

<style scoped>
#app {
	display: flex;
	flex-flow: column;
	position: relative;
	overflow-x: hidden;
	min-height: 100vh;
}
.fade-leave-active {
  transition: opacity .3s;
}
.fade-enter-active {
    transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
